import { DeleteIcon } from "assets/images/svgs";
import { FC } from "react";
import { MinorDTO } from "utils/helpers/models/attendee/minor.dto";
import badgesBg from "assets/images/others/host-side-images/badgesBg.png";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import { confirmationPopup } from "utils/helpers/common/alert-service";
import useAttendee from "containers/attendee/useHooks";
import editProfileUser from "assets/images/others/host-side-images/editProfileUSer.png";

interface Props {
  minor: MinorDTO;
  onDeleteSuccess: (deletedMinorId: number) => void;
}

const MinorCard: FC<Props> = ({ minor, onDeleteSuccess }) => {
  const navigate = useNavigate();
  const { deleteMinor } = useAttendee();

  const goToDetail = (minorId: number) => {
    navigate(`${siteRoutes.familyDetail}?id=${minorId}`);
  };

  const handleDeleteMinor = async () => {
    const confirmation = await confirmationPopup();
    if (confirmation.isConfirmed) {
      // Pass a callback so the parent can remove this minor from its local state
      deleteMinor(minor.id, () => onDeleteSuccess(minor.id));
    }
  };

  return (
    <div
      className="relative flex flex-col items-center justify-center p-4 rounded-lg w-[235px] h-[260px] cursor-pointer"
      style={{ backgroundImage: `url(${badgesBg})` }}
      onClick={() => goToDetail(minor.id)}
    >
      <button
        className="absolute top-2 right-2 p-1"
        onClick={(e) => {
          e.stopPropagation();
          handleDeleteMinor();
        }}
      >
        <DeleteIcon className="w-5 h-5" />
      </button>
      <div
        className="hover:scale-110 transition-transform duration-300"
      >
        <img
          className="w-[98px] h-[98px] rounded-full"
          src={minor.profilePicUrl ? minor.profilePicUrl : editProfileUser}
          alt={minor.profilePicUrl}
        />
      </div>
      <span className="text-base font-semibold mt-2 text-blackie">
        {`${minor.firstName} ${minor.lastName}`}
      </span>
      <span className="text-sm mt-1 text-labelTextColor">
        @{minor.username}
      </span>
    </div>
  );
};

export default MinorCard;
